import gql from 'graphql-tag';

export default gql`
  query stadiumPackageTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          stadiumPackages {
            createPackageLabel
            selectYourGameLabel
            homeCityLabel
            homeTeamNameLabel
            limitedSeatsLabel
            soldOutLabel
            versusLabel
            disclaimerHeaderLabel
            disclaimerFirstBulletPointText
            disclaimerFirstBulletPointSubText
            disclaimerSecondBulletPointText
            disclaimerThirdBulletPointText
            termsAndConditionsHeader
            termsAndConditionsContent
            gameSelectedLabel
          }
        }
      }
    }
  }
`;
